module.exports = __webpack_public_path__ + "static/img/sec1-cont02@w.cb9aa8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgwatersolution/sec1-cont02@w.jpg
// module id = K/H5
// module chunks = 0